export const SHOULD_PERSIST_CACHE = true;
export const CACHE_ENV = "prod";
